import { useQuery } from "@tanstack/react-query";
import type { EventInfo } from "@rekati/api";
import { api, keys } from "../../app/api";
import { FALLBACK } from "../../content/event";

/** `GET /v1/sessions`: the event's facts, `rsvp_enabled`, and the lineup. */
export function useEventQuery() {
  return useQuery({ queryKey: keys.event, queryFn: api.sessions, staleTime: 5 * 60_000 });
}

/** `GET /v1/brand`: organiser and powered-by names and logos. */
export function useBrandQuery() {
  return useQuery({ queryKey: keys.brand, queryFn: api.brand, staleTime: 30 * 60_000 });
}

export interface EventFacts {
  name: string;
  startsAt: string;
  endsAt: string;
  venueName: string;
  venueAddress: string | null;
  mapUrl: string | null;
  rsvpEnabled: boolean;
  /** True while the facts come from the copy fallback, not the API. */
  provisional: boolean;
}

/**
 * The event's facts from the API, and the confirmed copy only while the API
 * has not answered, so the page never shows an empty date.
 */
export function eventFacts(event: EventInfo | undefined): EventFacts {
  return {
    name: event?.name || "Powering the Future of Healthcare",
    startsAt: event?.starts_at ?? FALLBACK.startsAt,
    endsAt: event?.ends_at ?? FALLBACK.endsAt,
    venueName: event?.venue_name ?? FALLBACK.venueName,
    venueAddress: event ? event.venue_address : FALLBACK.venueAddress,
    mapUrl: event?.venue_map_url ?? null,
    rsvpEnabled: event?.rsvp_enabled ?? false,
    provisional: !event,
  };
}
